import React from "react";
import "./PageStyles.css";

const AboutPage = () => {
  return (
    <div className="page-container">
      <h2>About the Author</h2>

      {/* This new wrapper will let us use Flexbox to put
        the image and text side-by-side.
      */}
      <div className="about-content-wrapper">
        {/* This is your image. I've used a placeholder.
          IMPORTANT: Change the 'src' to the actual path of your photo,
          for example: '/your-photo-filename.jpg'
        */}
        <img
          src="/dawid-photo.jpg"
          alt="Dawid Szafranski"
          className="about-image"
        />

        {/* This div now wraps all your text paragraphs */}
        <div className="about-text-content">
          <p>
            Welcome to Szafranski Computing. My name is Dawid Szafranski, and my
            journey to mastering modern technology wasn't a straight line. I
            began my career not in a technology or software company, but in the
            world of academic science.
          </p>
          <p>
            Armed with a Ph.D. in Geophysics from Texas A&M, my foundational
            work involved developing complex numerical simulations and
            sophisticated algorithms to model the earth. This deep-rooted
            expertise in computation and data analysis was the catalyst for my
            pivot into the heart of the tech industry, where I now apply the
            same rigorous, first-principles thinking to software engineering.
          </p>
          <p>
            Today, as an AWS Certified Solutions Architect and a Software
            Engineer at Blue Origin, I build the backbone of modern technology.
            My professional focus is on the tools that enable innovation at
            scale: cloud computing (AWS), DevOps automation (Terraform,
            Ansible), and container orchestration (Kubernetes). From designing
            APIs and eventing platforms to developing CI/CD pipelines and
            contributing to AI agent platforms, my experience spans the full
            software lifecycle.
          </p>
          <p>
            Szafranski Computing is my space to share that unique perspective—to
            bridge the gap between complex theory and real-world implementation.
            My goal is to provide you with the insights and tutorials you need
            to tackle your own ambitious projects in software, cloud, and data.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
